import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import { computed, ref } from "vue";
import FilialeSelector from "@/components/FilialeSelector.vue";
import ProvinciaSelector from "@/components/ProvinciaSelector.vue";
import { Filiale } from "@/models/filiale";
import { useBookingStore } from "./store";
import MSBookingsFrame from "@/components/MSBookingsFrame.vue";
import { GetFiliali } from "@/services/FilialiProvider";


export default /*@__PURE__*/_defineComponent({
  __name: 'Booking',
  setup(__props) {

const bookingStore = useBookingStore();

const step = ref(1);

GetFiliali().then((ff) => {
  bookingStore.SET_FILIALI(ff);
});

const provincia = computed<string>({
  get: (): string => {
    const p = bookingStore.Provincia;
    return p === undefined ? "" : p;
  },
  set: (value: string): void => {
    bookingStore.SET_PROVINCIA(value);
  },
});

function setProvincia(value: string) {
  filiale.value = undefined;
  provincia.value = value;
  step.value = 2;
}

const filiale = computed<{ filiale: Filiale; pos: number } | undefined>({
  get: (): { filiale: Filiale; pos: number } | undefined => {
    return bookingStore.Filiale;
  },
  set: (event: { filiale: Filiale; pos: number } | undefined): void => {
    if (process.env.VUE_APP_DEMO === "true" && event !== undefined) {
      event.filiale.PublicUrl =
        event.pos % 2 == 0
          ? "https://outlook.office365.com/owa/calendar/BAPSFilialediTest2@progesoftware.it/bookings/"
          : "https://outlook.office365.com/book/Test11@progesoftware.it/";
      event.filiale.BookingsId =
        event.pos % 2 == 0
          ? "FilialediRagusa2@progesoftware.it"
          : "ProgeSoftwaresrl52@progesoftware.it";
    }
    bookingStore.SET_FILIALE(event);
  },
});

function setFiliale(event: { filiale: Filiale; pos: number }) {
  filiale.value = event;
  step.value = 3;
}

return (_ctx: any,_cache: any) => {
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper_window_item = _resolveComponent("v-stepper-window-item")!
  const _component_v_stepper_window = _resolveComponent("v-stepper-window")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_stepper, {
      modelValue: step.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((step).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_stepper_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_stepper_item, {
              complete: step.value > 1,
              value: 1,
              editable: step.value > 1,
              "edit-icon": "mdi-map-marker",
              color: "#102a63",
              title: "Provincia"
            }, null, 8, ["complete", "editable"]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_stepper_item, {
              complete: step.value > 2,
              value: 2,
              editable: step.value > 2,
              "edit-icon": "mdi-office-building-marker-outline",
              color: "#102a63",
              title: "Filiale"
            }, null, 8, ["complete", "editable"]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_stepper_item, {
              value: 3,
              color: "#102a63",
              title: "Dettaglio"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_stepper_window, { class: "pa-0 ma-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_stepper_window_item, {
              value: 1,
              class: "pa-0 ma-0"
            }, {
              default: _withCtx(() => [
                _createVNode(ProvinciaSelector, {
                  onSelect: _cache[0] || (_cache[0] = ($event: any) => (setProvincia($event)))
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_stepper_window_item, {
              value: 2,
              class: "pa-0 ma-0"
            }, {
              default: _withCtx(() => [
                _createVNode(FilialeSelector, {
                  provincia: provincia.value,
                  onSelect: _cache[1] || (_cache[1] = ($event: any) => (setFiliale($event)))
                }, null, 8, ["provincia"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_stepper_window_item, {
              value: 3,
              class: "pa-0 ma-0"
            }, {
              default: _withCtx(() => [
                (step.value == 3)
                  ? (_openBlock(), _createBlock(MSBookingsFrame, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})